import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import WareRackEditModal from "./WareRackEditModal";
import WareProductOverview from "./WareProductOverview";

//đợi sửa/không thể sửa/sản phẩm PET và lưu kho
const TAB_SCREEN = [
    { label: "Đợi sửa", value: 1 },
    { label: "Không thể sửa (Do Ranus)", value: 2 },
    { label: "Không thể sửa (Do khách hàng)", value: 3 },
    { label: "Sản phẩm/PET lưu kho", value: 4 },
];

export const StatusReturnProduct = {
    GOOD: 1,
    REPAIRABLE: 2,
    NOT_REPAIRABLE_RANUS: 3,
    NOT_REPAIRABLE_CUSTOMER: 4,
};

export const StatusReturnProductName = {
    GOOD: "Tốt",
    REPAIRABLE: "Đợi sửa",
    NOT_REPAIRABLE_RANUS: "Không thể sửa (Do Ranus)",
    NOT_REPAIRABLE_CUSTOMER: "Không thể sửa (Do khách hàng)",
};

function WareRackOverview(props) {
    const [tabIndex, setTabIndex] = useState(4);
    const [showRackEdit, setShowRackEdit] = useState(false);

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a className={tabIndex == item.value ? "nav-link active" : "nav-link btn-light"} onClick={() => setTabIndex(item.value)}>
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    return (
        <>
            <Wrapper>
                <Breadcrumbs currentPage="Tổng quan kho hàng" />
                {_renderTab}
                {tabIndex == 1 && <WareProductOverview returnStatus={StatusReturnProduct.REPAIRABLE} />}
                {tabIndex == 2 && <WareProductOverview returnStatus={StatusReturnProduct.NOT_REPAIRABLE_RANUS} />}
                {tabIndex == 3 && <WareProductOverview returnStatus={StatusReturnProduct.NOT_REPAIRABLE_CUSTOMER} />}
                {tabIndex == 4 && (
                    <section className="render-lst-button">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowRackEdit(true);
                            }}
                        >
                            Tùy chỉnh Rack - Slot - Bin
                        </button>
                    </section>
                )}
            </Wrapper>
            <WareRackEditModal show={showRackEdit} onClose={() => setShowRackEdit(false)} />
        </>
    );
}

export default WareRackOverview;

const Wrapper = styled.div`
    section.render-lst-button {
        margin: 12px 0;
    }

    section.render-lst-button .btn-primary {
        background: #343c49 !important;
        border: none !important;
    }

    .lst-image img {
        width: 92px;
        height: 92px;
        object-fit: contain;
    }

    tbody tr {
        background: white;
    }

    .image-section {
        display: flex;
        align-items: flex-start;
    }

    .app-product-name {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 8px;
    }

    .app-product-attribute {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .app-product-detail {
        height: 92px;
        display: flex;
        flex-direction: column;
        flex-grow: 0;
    }

    .wait-to-fix {
        margin-top: auto;
    }

    .order-return-row {
        display: flex;
        margin: 10px 0;
    }

    .order-return-row div:first-child {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 40%;
        text-overflow: ellipsis;
    }

    .order-return-row div:nth-child(2) {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex: 1;
    }

    .list-image-note img {
        width: 92px;
        height: 92px;
        margin: 10px;
    }
`;
